import { FC } from 'react'
import { ReactSVG } from 'react-svg'

import './style.scss'

interface TableProps {
  className?: string,
  style?: any,
  name: string,
  size?: number,
  color?: string,
  onClick?(): void,
  onMouseEnter?(): void,
  onMouseLeave?(): void
}

const Icon:FC<TableProps> = ({ className = '', style, name, size, color = '', onClick, onMouseEnter, onMouseLeave })  => {
  return (
    <ReactSVG
      src={`/assets/img/icons/${name}.svg`}
      className={`icon ${color ? 'text-' + color : ''} ${size ? 'fz-' + size : ''} ${className}`}
      style={style}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  )
}

export { Icon }